import styled from "styled-components";

import Colors from "@constants/Colors";
import {
  Box,
  Button,
  Container,
  Drawer,
  Grid,
  Typography,
} from "@mui/material";
import { ZIndex } from "@src/constants";

export const StyledContainer = styled(Container)`
  padding: 0 !important;
  max-width: 100vw !important;
`;

export const StyledDrawer = styled(Drawer)`
  @media (min-width: 600px) {
    display: block;
  }
  .MuiDrawer-paper {
    height: calc(100% - 44px);
    box-sizing: border-box !important;
    top: 44px;
    min-width: 298px !important;
    border-radius: 0px 16px 16px 0px;
    z-index: ${ZIndex.LEVEL_3};
  }
`;

export const StyledLocationBox = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border: 1px solid ${Colors.neutral_gray_300};
  border-radius: 8px;
  padding: 6px 12px;
  background: ${Colors.white};
  .icon {
    border-radius: 0px;
    padding: 0px;
    background-color: transparent;
    cursor: pointer;
    &:hover {
      background-color: transparent;
    }
  }
`;

export const StyledGrid = styled(Grid)`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  background: ${Colors.white} !important;
  position: sticky !important;
  top: 44px;
  justify-content: space-between;
  padding: 8px;
  box-shadow: ${Colors.Elevation_4};
  border-radius: 0px 0px 8px 8px;
  z-index: ${ZIndex.LEVEL_4};
`;

export const StyledTypography = styled(Typography)`
  user-select: none;
  cursor: pointer;
  font-family: Ringside Regular-Book;
  font-weight: 325;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  align-items: center;
  height: 32px;
  font-style: normal;
  color: ${Colors.neutral_gray_500};
`;

export const LogOutModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  max-width: 250px;
  width: 100vw;
  height: 100vh;
  max-height: 220px;
  background: ${Colors.white};
`;

export const LeavePageModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  max-width: 300px;
  width: 100vw;
  height: 100vh;
  max-height: 180px;
  background: ${Colors.white};
`;

export const LogOutTextWrapper = styled.div`
  font-family: Ringside Regular-Book;
  font-style: normal;
  font-weight: 325;
  font-size: 16px;
  line-height: 24px;
  width: 100%;
  height: 48px;
  text-align: center;
  padding: 24px 16px;
  color: ${Colors.black};
`;

export const LogOutButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  width: 100%;
  height: 40px;
`;

export const CustomButtonLogOut = styled(Button)<{
  textColor: string;
  backgroundColor: string;
}>`
  &.MuiButton-root {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    width: 123.5px;
    height: 40px;

    border-radius: 8px;

    font-family: Ringside Regular-Black;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    text-transform: capitalize;
    color: ${(props) => props.textColor};
    background: ${(props) => props.backgroundColor};
    &:hover {
      color: ${(props) => props.textColor};
      background: ${(props) => props.backgroundColor};
    }
  }
`;

export const StyledIcon = styled("img")`
  filter: invert(38%) sepia(73%) saturate(393%) hue-rotate(193deg)
    brightness(83%) contrast(100%);
  height: 24px;
  width: 24px;
  margin: 10px 0px;
`;
